interface ProfileStatsProps {
    entryCount: number
    karma: number
    followerCount: number
    followingCount: number
    onFollowersClick: () => void
    onFollowingClick: () => void
}

export function ProfileStats({
    entryCount,
    karma,
    followerCount,
    followingCount,
    onFollowersClick,
    onFollowingClick
}: ProfileStatsProps) {
    return (
        <div className="flex items-center gap-4 text-sm">
            <div className="flex items-center gap-1.5">
                <span className="font-poppins font-bold text-gray-900 dark:text-white">{entryCount}</span>
                <span className="text-gray-500 dark:text-gray-400 font-poppins">entry</span>
            </div>
            <div className="flex items-center gap-1.5">
                <span className="font-poppins font-bold text-gray-900 dark:text-white">{karma}</span>
                <span className="text-gray-500 dark:text-gray-400 font-poppins">karma</span>
            </div>
            <button
                onClick={onFollowersClick}
                className="flex items-center gap-1.5 hover:text-mavi-600 dark:hover:text-mavi-400 transition-colors cursor-pointer"
            >
                <span className="font-poppins font-bold text-gray-900 dark:text-white">{followerCount}</span>
                <span className="text-gray-500 dark:text-gray-400 font-poppins">takipçi</span>
            </button>
            <button
                onClick={onFollowingClick}
                className="flex items-center gap-1.5 hover:text-mavi-600 dark:hover:text-mavi-400 transition-colors cursor-pointer"
            >
                <span className="font-poppins font-bold text-gray-900 dark:text-white">{followingCount}</span>
                <span className="text-gray-500 dark:text-gray-400 font-poppins">takip</span>
            </button>
        </div>
    )
}
